/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import abstractContractClaimTranslations from "./abstractContractClaimTranslations";

const vehicleContractTranslations = {
  label: "Fahrzeugkaufvertrag",
  buyerOrSeller: {
    label: "Käufer oder Verkäufer?",
    question: "Sind Sie der Käufer oder Verkäufer?",
    options: {
      buyer: { label: "Käufer" },
      seller: { label: "Verkäufer" },
    },
  },
  isNewVehicle: {
    label: "Neuwagen?",
    question: "Handelt es sich bei dem Fahrzeug um einen Neuwagen?",
    options: {
      yes: { label: "Ja" },
      no: { label: "Nein" },
      true: { label: "Ja" },
      false: { label: "Nein" },
    },
  },
  vehicleMake: {
    label: "Marke",
    question: "Bitte wählen Sie die Marke des Fahrzeugs aus",
  },
  model: {
    label: "Modell",
    question: "Wie heißt das Modell des Fahrzeugs?",
  },
  vehicleId: {
    label: "Fahrzeug-Identifikationsnummer",
    question: "Wenn sie Ihnen gerade vorliegt, geben Sie bitte die Fahrzeug-Identifikationsnummer an - Sie finden diese im Fahrzeugbrief.",
  },
  purchasePrice: {
    label: "Kaufpreis",
    question: "Wie hoch war der vereinbarte Kaufpreis?",
  },
  isThirdPartyFinanced: {
    label: "Fremdfinanzierung?",
    question: "Wurde das Fahrzeug durch einen Kredit, Leasingvertrag oder eine sonstige Fremdfinanzierung erworben?",
    options: {
      true: { label: "Ja" },
      false: { label: "Nein" },
    },
  },
  locationOfGood: {
    label: "Standort des Fahrzeugs",
    question: "Wo befindet sich das Fahrzeug jetzt?",
    options: {
      buyer: { label: (caseData: Record<string, any>) => (caseData.buyerOrSeller === "buyer" ? "bei mir" : "beim Käufer") },
      seller: { label: (caseData: Record<string, any>) => (caseData.buyerOrSeller === "buyer" ? "beim Verkäufer" : "bei mir") },
      elsewhere: { label: "an einem anderen Ort (z.B. Werkstatt)" },
      unknown: { label: "ich weiss es nicht" },
    },
  },
  hasDefects: {
    label: "Mängel?",
    question: (caseData: Record<string, any>) =>
      caseData.buyerOrSeller === "buyer"
        ? "Hat das Fahrzeug aus Ihrer Sicht Mängel bzw. ist es kaputt?"
        : "Behauptet der Käufer, dass das Fahrzeug mangelhaft bzw. kaputt ist?",
    options: {
      yes: { label: "Ja" },
      no: { label: "Nein" },
      true: { label: "Ja" },
      false: { label: "Nein" },
    },
  },
  isAccidentCar: {
    label: "Unfallwagen?",
    question: (caseData: Record<string, any>) =>
      caseData.buyerOrSeller === "buyer"
        ? "Besteht der Mangel darin, dass es ein Unfallfahrzeug ist?"
        : "Behauptet der Käufer, dass es sich um ein Unfallfahrzeug handelt?",
    options: {
      yes: { label: "Ja" },
      no: { label: "Nein" },
      true: { label: "Ja" },
      false: { label: "Nein" },
    },
  },
  defectsRecognitionDate: {
    label: "Mängel festgestellt am",
    question: (caseData: Record<string, any>) =>
      caseData.buyerOrSeller === "buyer" ? "Wann haben Sie die Mängel bemerkt?" : "Wann hat der Käufer den Mangel an Sie gemeldet?",
  },
  defectsDescriptionClient: {
    label: "Beschreibung Mängel",
    question: (caseData: Record<string, any>) =>
      caseData.buyerOrSeller === "buyer"
        ? "Bitte beschreiben Sie hier die Mängel so genau wie möglich"
        : "Bitte beschreiben Sie hier, was der Käufer am Fahrzeug bemängelt",
    helperText:
      "Beschreiben Sie möglichst detailliert, damit wir eine gute Grundlage für das rechtliche Vorgehen haben " +
      "und führen Sie mehrere Mängel in einer Liste mit Spiegelstrichen auf.",
  },
  numberRepairAttempts: {
    label: "Ausbesserungsversuche?",
    question: (caseData: Record<string, any>) =>
      caseData.buyerOrSeller === "buyer"
        ? "Wurde vom Verkäufer bereits versucht, die Mängel zu beheben und falls ja, wie oft?"
        : "Haben Sie bereits versucht die Mängel zu beheben und falls ja, wie oft?",
    options: {
      0: { label: "Nein" },
      1: { label: "Ja, einmal" },
      2: { label: "Ja, zweimal" },
      3: { label: "Ja, dreimal oder häufiger" },
    },
  },
  numberReplacementAttempts: {
    label: "Neulieferungsversuche?",
    question: (caseData: Record<string, any>) =>
      caseData.buyerOrSeller === "buyer"
        ? "Wurde vom Verkäufer bereits versucht, das Fahrzeug neu zu liefern und falls ja, wie oft?"
        : "Haben Sie bereits versucht, das Fahrzeug neu zu liefern und falls ja, wie oft?",

    options: {
      0: { label: "Nein" },
      1: { label: "Ja, einmal" },
      2: { label: "Ja, zweimal" },
      3: { label: "Ja, dreimal oder häufiger" },
    },
  },
  mileageAtPurchase: {
    label: "Kilometerstand bei Kauf",
    question: "Wie hoch war der Kilometerstand bei Kauf?",
    helperText: "Zum Beispiel 50000. Bei einem Neuwagen geben Sie einfach “0” an.",
  },
  currentMileage: {
    label: "Aktueller Kilometerstand",
    question: "Wie hoch ist der aktuelle Kilometerstand?",
  },
  ...abstractContractClaimTranslations,
};

export default vehicleContractTranslations;
